// Общие сведения о типах документов для главной, распознавания и истории:
// подписи, иконки, пастельный тон плитки и адрес карточки результата.
import { BookUser, Contact2, FileSignature } from "lucide-react";
import { CIVIL_DOC_KINDS, isCivilDocType } from "./civilDocs";

export const MAIN_DOC_TYPES = [
  {
    key: "passport",
    label: "Паспорт",
    description: "Заграничный и внутренний",
    Icon: BookUser,
    tone: "lavender",
  },
  {
    key: "drivers_license",
    label: "Права",
    fullLabel: "Водительское удостоверение",
    description: "Любая страна, обе стороны",
    Icon: Contact2,
    tone: "mint",
  },
  {
    key: "contract",
    label: "Договор",
    description: "Справки и любые документы целиком",
    Icon: FileSignature,
    tone: "peach",
  },
];

// короткие подписи для узких плиток выбора типа
const CIVIL_COMPACT = {
  ru_birth_certificate: "Свид. о рождении",
  ru_divorce_certificate: "Расторжение брака",
  ru_criminal_record: "Справка МВД",
  ru_school_certificate: "Аттестат",
  ru_diploma: "Диплом",
};

export const CIVIL_TILES = CIVIL_DOC_KINDS.map((k) => ({
  key: k.key,
  label: k.label,
  compact: CIVIL_COMPACT[k.key] || k.short,
  short: k.short,
  description: k.description,
  Icon: k.Icon,
  tone: "butter",
}));

const BY_KEY = Object.fromEntries(
  [...MAIN_DOC_TYPES, ...CIVIL_TILES].map((t) => [t.key, t]),
);

export const docTypeMeta = (type) => BY_KEY[type] || BY_KEY.passport;

export const getDocUrl = (docType, id) => {
  if (docType === "drivers_license") return `/dl/${id}`;
  if (isCivilDocType(docType)) return `/doc/${id}`;
  if (docType === "contract") return `/contract/${id}`;
  return `/passport/${id}`;
};
